import { createFileRoute } from '@tanstack/react-router'
import { Suspense } from 'react'

import { GuaranteeDetailPanel } from '#/modules/guarantee/front-office/guarantee-detail-panel/guarantee-detail-panel.tsx'

// No loader: the parent `$productName` route awaits the exact same query options, so its `<Outlet />`
// only renders once that cache entry exists, and the panel's `useSuspenseQuery` reads it without
// suspending. The list mounted alongside holds an observer on the same key, so it cannot be evicted
// while the panel is open.
//
// The boundary is therefore insurance, not a designed loading state — hence `fallback={null}` and no
// skeleton. It is here because without it a suspension would travel up to the parent boundary and
// swap the whole guarantee list for the page skeleton. Should the panel ever gain a query this route
// does not warm, give the boundary a real fallback then.
export const Route = createFileRoute(
  '/(customer)/_shell/contract-guarantees-v2/$subscriptionId/$productName/$guaranteeType',
)({
  component: GuaranteeDetailRoute,
})

function GuaranteeDetailRoute() {
  const { subscriptionId, productName, guaranteeType } = Route.useParams()
  return (
    <Suspense fallback={null}>
      <GuaranteeDetailPanel subscriptionId={subscriptionId} productName={productName} guaranteeType={guaranteeType} />
    </Suspense>
  )
}
